import { createGenericApiSlice } from "../../../Api/Factory/genericApiFactory";
import { TagTypes } from "../../../Api/Types/tagTypes";
import { BankAccount } from "../Types/bankAccountTypes";

export const bankAccountsApi = createGenericApiSlice<BankAccount>({
	reducerPath: "bankAccountsApi",
	tag: TagTypes.BankAccount,
	endpoint: "bank-account",
});

export const {
	useGetAllQuery: useGetBankAccountsQuery,
	useGetByIdQuery: useGetBankAccountByIdQuery,
	useCreateMutation: useCreateBankAccountMutation,
	useUpdateMutation: useUpdateBankAccountMutation,
	useDeleteMutation: useDeleteBankAccountMutation,
} = bankAccountsApi;
